import { createElementObject, createPathComponent, extendContext } from './core';
// import { Polyline as LeafletPolyline } from '@anlan/gs-map';
import L from '@anlan/gs-map';
import type { LatLngExpression, Polyline as LeafletPolylineInstance, PolylineOptions } from '@anlan/gs-map';
import type { ReactNode } from 'react';
import type { LeafletContextInterface, PathProps } from './core';
const LeafletPolyline = L.Polyline;

export interface PolylineProps extends PolylineOptions, PathProps {
    children?: ReactNode
    positions: LatLngExpression[] | LatLngExpression[][]
}

export const Polyline = createPathComponent(function createPolyline({ positions , ...options }: PolylineProps, ctx: LeafletContextInterface) {
    const polyline = new LeafletPolyline(positions, options);
    return createElementObject(polyline, extendContext(ctx, {
        overlayContainer: polyline
    }));
}, function updatePolyline(layer: LeafletPolylineInstance, props: PolylineProps, prevProps: PolylineProps) {
    if (props.positions !== prevProps.positions) {
        layer.setLatLngs(props.positions);
    }
});
